import React, { Component } from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { connect } from 'react-redux';
import { closeContactUsModal } from 'store/modules/modals';
import ContactUsModalForm from '../ContactUs/ContactUsModalForm';
import { sendFeedbackAction } from 'store/modules/feedback';

import AlertMessage from 'components/AlertMessage';
import classnames from 'classnames';

class ContactUsModal extends Component {
  state = {
    showAlert: false,
  };
  sendFeedback = async (values, setSubmitting, setErrors, resetForm) => {
    const { sendFeedbackAction, i18n } = this.props;
    const body = {
      feedback: {
        message: values.message,
        email: values.email,
        name: values.name,
      },
    };
    const response = await sendFeedbackAction(body, setSubmitting, setErrors);
    if (response.status === 201) {
      resetForm();
      this.setState({ showAlert: true });
      setTimeout(() => {
        this.setState({ showAlert: false });
        this.props.close();
      }, 4000);
    }
  };

  render() {
    const { showAlert } = this.state;
    const { isShown, close, i18n } = this.props;

    return (
      <Modal isOpen={isShown}>
        {showAlert && (
          <AlertMessage text={i18n.toast.success.contact_us_submit} />
        )}
        <ModalHeader toggle={close}>
          <div className="h2-title">Contact us</div>
          <div className="separator-line" />
          <div className="text">
            Whether you have questions, suggestions, or other comments, we'd
            love to hear from you!
          </div>
        </ModalHeader>
        <ContactUsModalForm handleSubmit={this.sendFeedback} />
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isShown: state.modals.contactUsVisibility,
});

const mapDispatchToProps = {
  close: closeContactUsModal,
  sendFeedbackAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContactUsModal);



// WEBPACK FOOTER //
// ./src/components/Modals/ContactUsModal.js